module.exports = __webpack_public_path__ + "img/soft_2.23e4093c.png";